import { NgModule } from '@angular/core';
import { PhoneNumberPipe } from './phone-number.pipe';


@NgModule({
    imports: [],
    exports: [PhoneNumberPipe],
    declarations: [PhoneNumberPipe],
    providers: [],
})
export class PhoneNumberPipeModule { }
